import facebook from './facebook';
import twitter from './twitter';
import email from './email';
import sms from './sms';
import more from './more';
import instagram from './instagram';

export default {
  facebook,
  twitter,
  email,
  sms,
  more,
  instagram,
};
